var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCgrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1372_9268)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1687 22.6897L5.77219 29.0881C4.79037 29.3322 3.86707 29.7667 3.0556 30.3666C2.24413 30.9666 1.56057 31.72 1.04445 32.5833C0.528332 33.4467 0.189918 34.4028 0.0486443 35.3966C-0.0926289 36.3904 -0.0339659 37.4021 0.221367 38.3733L3.90778 53.8965C4.3349 55.8723 5.53414 57.5999 7.24304 58.701C8.95194 59.8021 11.0312 60.187 13.0257 59.7715L22.1351 57.6444L26.1621 61.3247C27.32 62.3798 29.5164 62.1097 30.1719 61.0968C30.6998 59.7124 30.6742 56.9859 31.2361 55.5172L40.4307 53.3732C41.4117 53.1281 42.3341 52.6929 43.1447 52.0926C43.9552 51.4923 44.6378 50.7387 45.1531 49.8755C45.6684 49.0122 46.0061 48.0563 46.1468 47.063C46.2876 46.0697 46.2284 45.0585 45.973 44.0879L42.2867 28.5647C42.0803 27.5836 41.6803 26.6527 41.1095 25.8256C40.5387 24.9985 39.8085 24.2916 38.961 23.7455C38.1134 23.1994 37.1653 22.825 36.1712 22.6438C35.1771 22.4626 34.1567 22.4782 33.1687 22.6897Z",
    fill: "#C1365B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5733 22.369L7.16821 28.7589C5.19127 29.262 3.49644 30.5223 2.45575 32.2631C1.41506 34.004 1.11353 36.0831 1.61739 38.0441L5.30381 53.5673C5.51133 54.5514 5.91268 55.4851 6.48491 56.3151C7.05714 57.145 7.78888 57.8548 8.63833 58.4037C9.48778 58.9526 10.4382 59.3299 11.4351 59.514C12.4319 59.698 13.4555 59.6851 14.4473 59.4761L23.5567 57.3489L27.5836 61.0293C27.7986 61.2794 28.0791 61.4661 28.394 61.5686C28.709 61.6712 29.0464 61.6858 29.3691 61.6108C29.6919 61.5359 29.9876 61.3742 30.2238 61.1435C30.46 60.9129 30.6276 60.6222 30.7081 60.3033L32.6661 55.2387L41.8523 53.0946C42.8333 52.8496 43.7557 52.4144 44.5663 51.8141C45.3768 51.2137 46.0593 50.4602 46.5746 49.5969C47.0899 48.7337 47.4277 47.7778 47.5684 46.7845C47.7092 45.7911 47.65 44.78 47.3946 43.8094L43.6742 28.2271C43.4658 27.2493 43.0649 26.3219 42.4944 25.4979C41.9239 24.674 41.1951 23.9698 40.3497 23.4256C39.5043 22.8814 38.5589 22.508 37.5676 22.3266C36.5764 22.1453 35.5589 22.1597 34.5733 22.369Z",
    fill: "#FF627A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1372_9268",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 32,
    width: 20,
    height: 19
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.652 36.9721C16.0993 34.6507 19.5046 34.1021 22.5099 35.5962C24.5276 32.9288 27.8223 31.9158 30.1721 33.3508C32.5218 34.7858 33.0582 38.1538 31.5513 41.142C31.4406 41.3614 31.3214 41.5809 31.1851 41.8004L26.4005 49.4733C26.2558 49.6928 26.1111 49.8954 25.9663 50.098C25.7359 49.9857 25.5115 49.8618 25.2938 49.7266L17.5635 44.9827C17.3422 44.8476 17.1293 44.7041 16.925 44.5522C14.2262 42.5516 13.2047 39.2849 14.652 36.9721Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1372_9268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0498 47.5065L30.0104 49.4817L18.415 31.9158H33.0498V47.5065Z",
    fill: "#F2EFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0104 49.4817L29.8146 49.6084L18.1426 31.9158H18.415L30.0104 49.4817Z",
    fill: "#F2EFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8143 49.6084L29.627 49.7265L17.8613 31.9158H18.1423L29.8143 49.6084Z",
    fill: "#F1EEF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.627 49.7265L29.4312 49.8531L17.5889 31.9158H17.8613L29.627 49.7265Z",
    fill: "#F1EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4311 49.8531L29.2353 49.9798L17.3164 31.9158H17.5888L29.4311 49.8531Z",
    fill: "#F0ECEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2357 49.9798L29.0654 50.0979H29.0399L17.0869 31.9917L17.2061 31.9158H17.3168L29.2357 49.9798Z",
    fill: "#EFEBEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.759 50.0979L16.8911 32.1183L17.0869 31.9917L29.0399 50.0979H28.759Z",
    fill: "#EEEAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4863 50.098L16.7036 32.2366L16.8909 32.1184L28.7587 50.098H28.4863Z",
    fill: "#EEE9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2054 50.098L16.5078 32.3632L16.7036 32.2366L28.4863 50.098H28.2054Z",
    fill: "#EDE8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.933 50.0979L16.312 32.4898L16.5078 32.3632L28.2054 50.0979H27.933Z",
    fill: "#ECE7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6518 50.0979L16.1245 32.6164L16.3118 32.4897L27.9328 50.0979H27.6518Z",
    fill: "#EBE6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3794 50.0979L15.9287 32.743L16.1245 32.6163L27.6518 50.0979H27.3794Z",
    fill: "#EBE5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.107 50.098L15.7329 32.8697L15.9287 32.743L27.3794 50.098H27.107Z",
    fill: "#EAE4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.826 50.0979L15.5371 32.9962L15.7329 32.8696L27.107 50.0979H26.826Z",
    fill: "#E9E3E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5539 50.0979L15.3501 33.1144L15.5374 32.9962L26.8263 50.0979H26.5539Z",
    fill: "#E9E2E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2729 50.0979L15.1543 33.241L15.3501 33.1144L26.5539 50.0979H26.2729Z",
    fill: "#E8E1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0005 50.0979L14.9585 33.3676L15.1543 33.241L26.273 50.0979H26.0005Z",
    fill: "#E7E0E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7194 50.098L14.771 33.4943L14.9583 33.3677L26.0003 50.098H25.7194Z",
    fill: "#E6DFE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.447 50.0979L14.5752 33.6209L14.771 33.4943L25.7194 50.0979H25.447Z",
    fill: "#E6DEE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1745 50.0979L14.3794 33.7475L14.5752 33.6208L25.447 50.0979H25.1745Z",
    fill: "#E5DDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8936 50.0979L14.1836 33.8656L14.3794 33.7474L25.1745 50.0979H24.8936Z",
    fill: "#E4DCDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6214 50.098L13.9966 33.9923L14.1839 33.8657L24.8939 50.098H24.6214Z",
    fill: "#E3DBDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.34 50.098L13.8003 34.1189L13.9961 33.9923L24.621 50.098H24.34Z",
    fill: "#E3DADC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0676 50.0979L13.6045 34.2455L13.8003 34.1189L24.34 50.0979H24.0676Z",
    fill: "#E2D9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7955 50.0979L13.4175 34.3721L13.6048 34.2455L24.0679 50.0979H23.7955Z",
    fill: "#E1D8DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5145 50.098L13.2217 34.4988L13.4175 34.3722L23.7955 50.098H23.5145Z",
    fill: "#E0D7D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.242 50.098L13.2046 34.8871V34.5072L13.2216 34.4988L23.5145 50.098H23.242Z",
    fill: "#E0D6D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9611 50.098L13.2046 35.3091V34.8871L23.242 50.098H22.9611Z",
    fill: "#DFD5D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6886 50.0979L13.2046 35.7227V35.3091L22.9611 50.0979H22.6886Z",
    fill: "#DED4D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4077 50.0979L13.2046 36.1447V35.7227L22.6886 50.0979H22.4077Z",
    fill: "#DED3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1353 50.0979L13.2046 36.5584V36.1448L22.4077 50.0979H22.1353Z",
    fill: "#DDD2D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8628 50.0979L13.2046 36.9804V36.5583L22.1353 50.0979H21.8628Z",
    fill: "#DCD1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5819 50.098L13.2046 37.3941V36.9805L21.8628 50.098H21.5819Z",
    fill: "#DBD0D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3095 50.0979L13.2046 37.8161V37.394L21.5819 50.0979H21.3095Z",
    fill: "#DBCFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0285 50.098L13.2046 38.2382V37.8162L21.3095 50.098H21.0285Z",
    fill: "#DACED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7561 50.0979L13.2046 38.6518V38.2382L21.0285 50.0979H20.7561Z",
    fill: "#D9CDCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4751 50.0979L13.2046 39.0738V38.6517L20.7561 50.0979H20.4751Z",
    fill: "#D8CCCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2027 50.0979L13.2046 39.4875V39.0739L20.4751 50.0979H20.2027Z",
    fill: "#D8CBCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9303 50.0979L13.2046 39.9095V39.4874L20.2027 50.0979H19.9303Z",
    fill: "#D7CACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2046 39.9095L19.9303 50.098H13.2046V39.9095Z",
    fill: "#D7CACC"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2422 35.4526C23.8345 34.6383 24.6376 33.9975 25.5666 33.5978C26.4956 33.1982 27.516 33.0545 28.5205 33.182C28.5205 33.182 31.4917 33.6125 31.9259 36.2123C31.9259 36.2123 33.0157 38.8122 29.9594 43.1594L25.8984 49.6675L30.6234 40.4244C30.6234 40.4244 32.4368 36.4656 29.9679 34.5916C29.9253 34.5916 27.6266 32.1606 23.2422 35.4526Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8407 11.1844C44.6314 11.839 44.1687 12.3844 43.5541 12.7009C42.9396 13.0175 42.2235 13.0792 41.563 12.8727C40.9029 12.6652 40.3528 12.2064 40.0336 11.597C39.7143 10.9877 39.652 10.2777 39.8603 9.62284L42.3122 1.81481C42.5234 1.1616 42.9864 0.61762 43.6004 0.3014C44.2143 -0.0148202 44.9294 -0.0776546 45.5899 0.126584C46.2474 0.337891 46.7946 0.797263 47.1132 1.40539C47.4318 2.01352 47.4963 2.72155 47.2926 3.37641L44.8407 11.1844Z",
    fill: "url(#paint0_linear_1372_9268)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M41.0525 10.543C41.019 10.6532 40.943 10.746 40.841 10.8013C40.7391 10.8566 40.6194 10.8699 40.5076 10.8384C40.4533 10.8203 40.403 10.7918 40.3599 10.7543C40.3167 10.7169 40.2814 10.6714 40.256 10.6204C40.2307 10.5693 40.2159 10.5139 40.2123 10.4571C40.2087 10.4004 40.2164 10.3435 40.2351 10.2897L43.0702 1.24928C43.102 1.13744 43.1772 1.04265 43.2793 0.985688C43.3814 0.928726 43.5022 0.914243 43.6151 0.945406C43.7242 0.985522 43.8134 1.06587 43.8642 1.16969C43.915 1.2735 43.9233 1.39274 43.8875 1.50252L41.0525 10.543Z",
    fill: "url(#paint1_linear_1372_9268)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6909 23.3902C54.1014 23.7499 53.392 23.863 52.7185 23.7048C52.045 23.5465 51.4623 23.1298 51.0982 22.5461C50.735 21.9603 50.6208 21.2557 50.7803 20.5865C50.9399 19.9174 51.3603 19.3381 51.9496 18.9755L58.9988 14.755C59.5896 14.3949 60.3003 14.2815 60.9752 14.4397C61.6502 14.5979 62.2343 15.0148 62.6 15.5991C62.9627 16.1836 63.0769 16.8869 62.9173 17.5547C62.7577 18.2225 62.3374 18.8003 61.7486 19.1612L54.6909 23.3902Z",
    fill: "url(#paint2_linear_1372_9268)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M52.2813 20.4191C52.2328 20.4501 52.1785 20.4712 52.1217 20.4812C52.0649 20.4912 52.0067 20.4899 51.9505 20.4773C51.8942 20.4647 51.8411 20.4411 51.7941 20.408C51.7471 20.3748 51.7072 20.3326 51.6768 20.284C51.648 20.2348 51.6293 20.1803 51.6219 20.1239C51.6144 20.0674 51.6183 20.0101 51.6333 19.9551C51.6483 19.9001 51.6742 19.8487 51.7095 19.8037C51.7447 19.7588 51.7886 19.7212 51.8385 19.6931L60.0031 14.772C60.0516 14.741 60.1057 14.7199 60.1625 14.7099C60.2193 14.6999 60.2776 14.7012 60.3339 14.7138C60.3902 14.7264 60.4433 14.7499 60.4903 14.7831C60.5373 14.8163 60.5771 14.8584 60.6075 14.907C60.6635 15.007 60.6779 15.1247 60.6477 15.235C60.6175 15.3454 60.545 15.4397 60.4457 15.4979L52.2813 20.4191Z",
    fill: "url(#paint3_linear_1372_9268)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5957 14.1051C24.7365 14.4165 24.938 14.6973 25.1886 14.9314C25.4392 15.1654 25.7339 15.3481 26.0558 15.4689C26.3778 15.5897 26.7207 15.6462 27.0647 15.6352C27.4088 15.6243 27.7473 15.546 28.0608 15.405C28.3738 15.2654 28.6561 15.0659 28.8914 14.8181C29.1268 14.5703 29.3105 14.279 29.4322 13.9607C29.554 13.6425 29.6114 13.3036 29.601 12.9633C29.5906 12.6231 29.5127 12.2883 29.3718 11.9779L25.9664 4.50751C25.8264 4.19635 25.6258 3.91572 25.3761 3.68177C25.1263 3.44781 24.8323 3.26517 24.511 3.14434C24.1897 3.02352 23.8475 2.9669 23.5041 2.97775C23.1606 2.98861 22.8228 3.06671 22.5099 3.20758C22.1961 3.34643 21.913 3.54529 21.6768 3.79276C21.4405 4.04023 21.2558 4.33146 21.1332 4.64978C21.0107 4.96811 20.9527 5.30727 20.9625 5.64786C20.9723 5.98845 21.0496 6.32379 21.1903 6.63468L24.5957 14.1051Z",
    fill: "url(#paint4_linear_1372_9268)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M28.2735 13.0162C28.3219 13.1207 28.409 13.2026 28.5168 13.2451C28.6246 13.2875 28.7448 13.2872 28.8523 13.2441C28.9562 13.1948 29.0361 13.1067 29.0744 12.9991C29.1127 12.8914 29.1063 12.7731 29.0566 12.6701L25.149 4.02641C25.1267 3.97321 25.094 3.92498 25.0526 3.88457C25.0112 3.84415 24.962 3.81238 24.9081 3.79113C24.8541 3.76988 24.7964 3.75958 24.7384 3.76085C24.6803 3.76211 24.6231 3.77492 24.5701 3.7985C24.4662 3.84777 24.3863 3.93591 24.348 4.04355C24.3097 4.15119 24.316 4.26951 24.3657 4.3725L28.2735 13.0162Z",
    fill: "url(#paint5_linear_1372_9268)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1372_9268",
    x1: 39.0291,
    y1: 5.06463,
    x2: 45.2794,
    y2: 7.02447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F6DE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ECC13F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1372_9268",
    x1: 43.5209,
    y1: 1.26031,
    x2: 40.5025,
    y2: 11.0524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1372_9268",
    x1: 54.3725,
    y1: 15.0453,
    x2: 57.7306,
    y2: 20.6178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F6DE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ECC13F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1372_9268",
    x1: 60.2744,
    y1: 15.1337,
    x2: 51.4976,
    y2: 20.5137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1372_9268",
    x1: 23.7776,
    y1: 1.47496,
    x2: 17.8372,
    y2: 4.17437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F6DE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ECC13F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1372_9268",
    x1: 18.8697,
    y1: -1.75694,
    x2: 23.0439,
    y2: 7.58734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1372_9268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCgrIcon);
export default __webpack_public_path__ + "static/media/cgrIcon.88f90e408cc22a3ce40964824ba8593f.svg";
export { ForwardRef as ReactComponent };